import React, { Component } from "react";

/**
 * Campo de título con área grande y label discreta.
 * Props:
 *  - value: string
 *  - onChange(value)
 */
export default class TitleSection extends Component {
  static defaultProps = {
    value: "",
  };

  handleChange = (e) => {
    this.props.onChange && this.props.onChange(e.target.value);
  };

  render() {
    const { value } = this.props;

    return (
      <>
        <section className="project-cover-section">
          <h3 className="project-subtitle">Título del proyecto</h3>
          <div className="project-cover-uploader">
            <textarea
              className="title-input-large"
              value={value}
              onChange={this.handleChange}
              rows={2}
              placeholder="Escribe un título potente…"
              style={{
                width: "100%",
                fontSize: "1.75rem", // texto grande
                lineHeight: 1.25,
                padding: "0.75rem 0.9rem",
                borderRadius: 8,
                border: "1px solid rgba(0,0,0,.15)",
                background: "var(--color-tarjeta,#fff)",
                outline: "none",
                resize: "vertical",
              }}
            />
          </div>
        </section>
      </>
    );
  }
}
